import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const withViewAccess = (Component) => {
    return (props) => {
        const { permissionsNames = [], roles = [], redirectOnDenied = false, ...restProps } = props;
        const { roleName, permissions = [] } = useSelector((state) => state.user);
        const havePermission = permissionsNames.some((permission) => permissions.includes(permission));
        if (havePermission || roles?.includes(roleName)) {
            return <Component {...restProps} />
        }

        if (redirectOnDenied) {
            return <Navigate to="/" replace />;
        }

        return null
    }
}

export default withViewAccess